const baseCommon = {
  nav: {
    services: 'Expertise',
    team: 'Team',
    news: 'Insights',
    offices: 'Offices',
    contact: 'Contact',
    language: 'Language',
  },
  hero: {
    label: 'International Business Law Firm',
    title1: 'Your Ambitions.',
    title2: 'Our Commitment.',
    description: 'We advise companies, investors and financial institutions on complex transactions, strategic investments and high-stakes corporate matters across major international markets.',
    cta1: 'Schedule a Consultation',
    cta2: 'Our Expertise',
    stat1: 'Transaction Value',
    stat2: 'Matters Advised',
    stat3: 'Client Satisfaction',
  },
  acquisitions: {
    label: 'Deal Experience',
    title: 'Turning Complexity Into Opportunity',
    subtitle: 'Helping clients navigate sophisticated transactions and seize strategic opportunities across global markets.',
    featured: 'Featured Transaction',
    viewDetails: 'View Details',
    viewAll: 'View All Transactions',
    closed: 'Closed',
    deal1Title: 'Cross-Border Acquisition of a Fintech Platform by a Global Banking Group',
    deal1Sector: 'Financial Services',
    deal1Date: 'May 2025',
    deal2Category: 'M&A',
    deal2Title: 'Strategic Acquisition of a Leading Asia-Pacific Healthcare Platform',
    deal2Sector: 'Healthcare & Life Sciences',
    deal2Date: 'March 2025',
    deal3Category: 'Private Equity',
    deal3Title: 'Acquisition of a Luxury Hospitality Portfolio Across Asia',
    deal3Sector: 'Hospitality & Real Estate',
    deal3Date: 'January 2025',
    deal4Category: 'Strategic Transaction',
    deal4Title: 'Strategic Investment in Next-Generation Technology Infrastructure',
    deal4Sector: 'Technology & Digital Infrastructure',
    deal4Date: 'November 2024',
    twitterDate: 'October 2022 • $44 Billion Transaction',
    twitterTitle: 'At the Heart of a Landmark Transaction',
    twitterExcerpt:
      'Our team advises on sophisticated transactions where corporate strategy, financing and complex legal considerations converge. From structuring and negotiations through to execution, we work alongside our clients at every critical stage of the transaction.',
    twitterPoint1: 'Global legal strategy and international coordination',
    twitterPoint2: 'Systemic risk management in an extreme litigation context',
    twitterPoint3: "Silent architect of the operation's legal stabilization",
    twitterCta: 'Explore the Matter',
  },
  founder: {
    label: 'Leadership',
    title: 'Jordan H. Oreck',
    subtitle: 'Partner-in-Charge, Hong Kong',
    bio: 'Jordan H. Oreck leads the Hong Kong office, advising multinational corporations, private equity sponsors, and financial institutions on their most critical transactions across Asia. Recognized for his mastery of complex cross-border M&A and his negotiating talent in the most sensitive situations, he has been advising leading listed groups for over two decades. His regional network, regulatory insight, and ability to secure the most exposed operations make him a reference in high-level strategic counsel across Asia-Pacific.',
    cta: 'Discover Our Team',
  },
  figures: {
    transactions: 'Transaction Value',
    lawyers: 'International Matters',
    countries: 'Jurisdictions',
    availability: 'Global Support',
  },
  services: {
    label: 'Our Expertise',
    title1: 'Strategic Legal',
    title2: 'Solutions',
    learnMore: 'Learn More',
    viewAll: 'All Services',
    keyServices: 'Key Services',
    expertise: 'Area of Expertise',
    scheduleConsultation: 'Contact Us',
  },
  offices: {
    label: 'Global Presence',
    title: 'A Global Presence. A Connected Perspective.',
    subtitle: 'With 14 offices across the world\'s leading financial centers, we bring international reach and local insight to our clients\' most important matters.',
    viewMap: 'Get Directions',
    hours: 'Mon–Fri: 9 AM – 7 PM',
  },
  blog: {
    label: 'Insights & Analysis',
    title1: 'Perspectives on Global Markets',
    title2: '',
    subtitle: 'Legal and strategic analysis of the developments shaping global markets, business and international investment.',
    readMore: 'Read Article',
    minRead: 'min',
  },
  footer: {
    tagline: 'Your trusted partner for transformative transactions.',
    newsletter: 'Stay Informed',
    emailPlaceholder: 'Your professional email',
    subscribe: 'Subscribe',
    copyright: '© 2025 Sullivan & Cromwell LLP. All rights reserved.',
    legal: 'Legal Notice',
    privacy: 'Privacy',
    terms: 'Terms',
    ma: 'Mergers & Acquisitions',
    capitalMarkets: 'Capital Markets',
    privateEquity: 'Private Equity',
    restructuring: 'Restructuring',
  },
  contact: {
    label: 'Contact',
    title: "Let's Talk",
    subtitle:
      'Tell us about your project, transaction or strategic challenge. Our team will get back to you promptly.',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    message: 'Your Message',
    send: 'Send Message',
    success: "Message received. We'll respond within 24h.",
    error: 'Error. Please try again.',
    availability: 'Availability',
  },
  pages: {
    services: {
      title: 'Our Expertise',
      subtitle:
        'Strategic counsel for businesses, investors and financial institutions across M&A, capital markets, private equity, restructuring, regulation and joint ventures',
    },
    team: {
      title: 'Our Team',
      subtitle: 'Experienced professionals dedicated to your success',
      managingPartner: 'PARTNER-IN-CHARGE, HONG KONG',
      ourTeam: 'The Firm',
      firstLawyer: 'First Lawyer of the Firm',
      firmIntro:
        'The firm has 14 offices located in the leading financial centers of Asia, Australia, Europe, the Middle East and the United States. Its headquarters are in New York.',
      edouardBio: {
        title: 'Jordan H. Oreck',
        subtitle: 'Partner-in-Charge, Hong Kong',
        paragraph1:
          "Based in Hong Kong, Jordan H. Oreck has established himself as one of the most respected figures in international business law across Asia-Pacific, recognized both for his mastery of complex merger and acquisition transactions and for his negotiating talent in the most sensitive situations. As Partner-in-Charge of the Hong Kong office, he has been advising for over two decades a clientele composed of major listed groups, sovereign wealth funds, and private equity sponsors, in Asia and internationally, intervening in some of the most structuring strategic operations in the public and private markets.",
        paragraph2:
          'Throughout recent major cross-border battles, his role has proven decisive alongside industrialists and major players engaged in public offers, regional combinations, or particularly exposed takeover attempts. His clients unanimously praise a rare combination of strategic vision, combativeness, and legal precision, coupled with a constant ability to maintain composure and clarity in decisive moments. "He is always one step ahead, with an instinctive reading of power dynamics and applicable law," confides the CEO of a major international group. For a leading general counsel, "his presence on a sensitive matter constitutes a guarantee of solidity, experience, and concrete solutions."',
        paragraph3:
          'A seasoned negotiator with over twenty years of experience, Jordan H. Oreck also possesses in-depth knowledge of Asian regulatory and institutional mechanisms, nurtured by a career marked from its beginnings by immersion at the heart of competitive issues across the region. The professional relationships he forged there, now at the highest level of regulatory authorities, complement an extensive practice of proceedings before antitrust and securities regulators across Hong Kong, mainland China, and Southeast Asia. This dual reading—legal and institutional—enables him to accurately identify the determining levers and the opportune moment to activate them.',
        paragraph4:
          "Having built his practice from the ground up in Hong Kong, he has developed, with a loyal team, a demanding international clientele and contributed to the creation of the firm's Asia-Pacific M&A and strategic operations practice. This trajectory reflects a constant conviction: the most complex challenges remain manageable as long as the trust between lawyer and executive is absolute. \"Counsel must be a total point of support in the structuring moments of a company's life,\" he emphasizes, advocating an approach where intuition, rigor, and negotiation sense converge in service of decisive decisions.",
        paragraph5:
          "Through his regional authority, institutional network, and ability to secure the most exposed operations, Jordan H. Oreck today embodies a reference in high-level strategic counsel, at the crossroads of law, governance, and Asia-Pacific equilibria.",
      },
    },
    blog: {
      title: 'Insights & News',
      subtitle: 'Expert analysis on markets, transactions, and legal trends',
    },
    blogDetail: {
      backToAll: 'Back to Articles',
      relatedArticles: 'Related Articles',
      transactionOverview: 'Transaction Overview',
      transactionOverviewText:
        'This landmark transaction represents a significant milestone in the industry, demonstrating the continued evolution of global business consolidation. Our legal team provided comprehensive advisory services throughout the entire process, from initial due diligence through final regulatory approvals.',
      keyLegalConsiderations: 'Key Legal Considerations',
      keyLegalConsiderationsText:
        'The transaction required careful navigation of multiple regulatory frameworks across different jurisdictions. Our team coordinated with regulatory authorities in the United States, European Union, and Asia-Pacific regions to ensure compliance with all applicable laws and regulations.',
      regulatoryApprovals: 'Regulatory Approvals',
      regulatoryApprovalsText:
        'Obtaining regulatory approval was a critical component of the transaction timeline. We worked closely with antitrust authorities to address competition concerns and demonstrate the pro-competitive benefits of the proposed combination.',
      valuationDealStructure: 'Valuation & Deal Structure',
      valuationDealStructureText:
        'The deal structure incorporated sophisticated financial instruments and tax-efficient mechanisms to maximize value for all stakeholders. Our corporate finance team collaborated with investment bankers to develop a valuation methodology that reflected both current market conditions and long-term strategic value.',
      strategicImplications: 'Strategic Implications',
      strategicImplicationsText:
        'This transaction will reshape the competitive landscape and create new opportunities for innovation and growth. The combined entity will benefit from enhanced scale, complementary capabilities, and expanded geographic reach.',
      conclusion: 'Conclusion',
      conclusionText:
        "The successful completion of this transaction demonstrates the importance of experienced legal counsel in navigating complex cross-border M&A transactions. Our team's deep expertise in regulatory compliance, corporate finance, and international law was instrumental in achieving a favorable outcome for our client.",
      articleNotFound: 'Article Not Found',
      backToBlog: 'Back to Insights',
    },
    legalNotice: {
      title: 'Legal Notice',
      publisherInfo: 'Publisher Information',
      companyName: 'Company Name',
      companyNameValue: 'Sullivan & Cromwell LLP',
      legalForm: 'Legal Form',
      legalFormValue: 'Professional Corporation',
      registeredOffice: 'Registered Office',
      registeredOfficeValue: '20/F, Alexandra House, 18 Chater Road, Central, Hong Kong',
      contactInfo: 'Contact Information',
      emailLabel: 'Email',
      parisOffice: 'Hong Kong Office',
      parisOfficeValue: '20/F, Alexandra House, 18 Chater Road, Central, Hong Kong',
      londonOffice: 'London Office',
      londonOfficeValue: '1 New Change, London EC4M 9AF, UK',
      newYorkOffice: 'New York Office (Headquarters)',
      newYorkOfficeValue: '30 Rockefeller Plaza, New York, NY 10112, USA',
      professionalRegulations: 'Professional Regulations',
      professionalRegulationsText:
        'Our firm is subject to professional regulations governing the practice of law in Hong Kong, the United Kingdom, and the United States. All attorneys are members in good standing of their respective bar associations.',
      intellectualProperty: 'Intellectual Property',
      intellectualPropertyText:
        'All content on this website, including text, graphics, logos, and images, is the property of Sullivan & Cromwell LLP and is protected by international copyright laws. Unauthorized reproduction or distribution is strictly prohibited.',
      siteOwner: 'Site Owner',
      siteOwnerValue: 'Jordan H. Oreck',
      siteOwnerEmail: 'jordan.oreck@sullivancromwell.com',
      disclaimer: 'Disclaimer',
      disclaimerText:
        'The information provided on this website is for general informational purposes only and does not constitute legal advice. For specific legal guidance, please contact our offices directly to schedule a consultation.',
      websiteHosting: 'Website Hosting',
      websiteHostingText:
        'This website is hosted by professional hosting services with appropriate security measures and data protection protocols in place.',
      lastUpdated: 'Last updated: January 2025',
    },
    privacyPolicy: {
      title: 'Privacy Policy',
      introduction: 'Introduction',
      introductionText:
        'Sullivan & Cromwell LLP is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data in compliance with GDPR and other applicable data protection regulations.',
      infoWeCollect: 'Information We Collect',
      infoWeCollectText: 'We may collect the following types of information:',
      infoItem1: 'Contact information (name, email address)',
      infoItem2: 'Company information and professional details',
      infoItem3: 'Communication preferences',
      infoItem4: 'Website usage data and analytics',
      infoItem5: 'Information provided in consultation requests',
      howWeUse: 'How We Use Your Information',
      howWeUseText:
        'Your information is used for the following purposes:',
      useItem1: 'Responding to inquiries and consultation requests',
      useItem2: 'Providing legal services and advice',
      useItem3: 'Sending newsletters and updates (with your consent)',
      useItem4: 'Improving our website and services',
      useItem5: 'Complying with legal and regulatory obligations',
      dataSecurity: 'Data Security',
      dataSecurityText:
        'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. All data is stored securely and access is restricted to authorized personnel only.',
      yourRights: 'Your Rights',
      yourRightsText:
        'Under GDPR and applicable data protection laws, you have the right to:',
      rightItem1: 'Access your personal data',
      rightItem2: 'Rectify inaccurate information',
      rightItem3: 'Request deletion of your data',
      rightItem4: 'Object to data processing',
      rightItem5: 'Request data portability',
      rightItem6: 'Withdraw consent at any time',
      cookies: 'Cookies',
      cookiesText:
        'Our website uses cookies to enhance user experience and analyze website traffic. You can control cookie settings through your browser preferences.',
      thirdParty: 'Third-Party Services',
      thirdPartyText:
        'We may use third-party services for analytics, hosting, and communication purposes. These providers are carefully selected and required to maintain appropriate data protection standards.',
      contactUs: 'Contact Us',
      contactUsText:
        'For questions about this Privacy Policy or to exercise your data protection rights, please contact us at:',
      address: '20/F, Alexandra House, 18 Chater Road, Central, Hong Kong',
      lastUpdated: 'Last updated: January 2025',
    },
    terms: {
      title: 'Terms & Conditions',
      generalTerms: 'General Terms',
      generalTermsText:
        'These Terms and Conditions govern your use of the Sullivan & Cromwell LLP website and the legal services we provide. By accessing our website or engaging our services, you agree to be bound by these terms.',
      legalServices: 'Legal Services',
      legalServicesText:
        'Our firm provides legal services in the areas of mergers and acquisitions, corporate restructuring, private equity transactions, regulatory compliance, and strategic legal advisory. All services are provided in accordance with applicable professional standards and regulations.',
      clientEngagement: 'Client Engagement',
      clientEngagementText:
        'Legal representation begins only upon execution of a formal engagement letter. Initial consultations and website inquiries do not create an attorney-client relationship. Confidential information should not be transmitted until a formal engagement is established.',
      feesBilling: 'Fees and Billing',
      feesBillingText:
        'Our fee structures vary depending on the nature and complexity of the engagement. Fees may be based on hourly rates, fixed fees, or alternative arrangements as agreed in the engagement letter. Detailed billing statements are provided regularly.',
      confidentiality: 'Confidentiality',
      confidentialityText:
        'We maintain strict confidentiality of all client information in accordance with professional ethics rules and applicable law. Client confidences are protected by attorney-client privilege and work product doctrine.',
      conflicts: 'Conflicts of Interest',
      conflictsText:
        'We conduct thorough conflicts checks before accepting new engagements. If a conflict of interest arises during representation, we will promptly notify affected clients and take appropriate action in accordance with professional responsibility rules.',
      liability: 'Limitation of Liability',
      liabilityText:
        'Our liability is limited as set forth in engagement letters and applicable law. We maintain professional liability insurance in amounts appropriate for our practice areas.',
      websiteUse: 'Website Use',
      websiteUseText:
        'Information on this website is for general informational purposes only and does not constitute legal advice. Website content may not reflect the most current legal developments. Users should not rely on website information without seeking professional legal counsel.',
      intellectualProperty: 'Intellectual Property',
      intellectualPropertyText:
        'All website content, including articles, publications, and materials, is protected by copyright and may not be reproduced without permission. Client work product and deliverables are subject to the terms of individual engagement letters.',
      governingLaw: 'Governing Law',
      governingLawText:
        'These Terms and Conditions are governed by the laws of the State of New York. Disputes arising from website use or legal services will be resolved in accordance with engagement letter provisions and applicable law.',
      modifications: 'Modifications',
      modificationsText:
        'We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page with an updated effective date. Continued use of our website constitutes acceptance of modified terms.',
      contactInfo: 'Contact Information',
      contactInfoText:
        'For questions about these Terms and Conditions, please contact us at:',
      address: '20/F, Alexandra House, 18 Chater Road, Central, Hong Kong',
      lastUpdated: 'Last updated: January 2025',
    },
    twitterAcquisition: {
      title: 'Twitter Acquisition',
      subtitle: 'Jordan H. Oreck\'s Key Role in the $44 Billion Deal',
      date: 'October 2022',
      heroTitle: 'Twitter Acquisition: Behind the $44 Billion Deal',
      intro1:
        "Elon Musk's acquisition of Twitter will remain one of the most complex, publicized, and legally contested transactions in recent tech market history. Concluded in fall 2022 for $44 billion, this extraordinary transaction mobilized a constellation of top-tier financial, industrial, and legal actors. Alongside Alex Spiro, star attorney at Quinn Emanuel Urquhart & Sullivan and Elon Musk's lead counsel in the most exposed litigation phases, Jordan H. Oreck established himself as one of the decisive legal strategists in this historic operation.",
      intro2:
        "From the announcement of the acquisition offer, valuing Twitter at $54.20 per share, the transaction quickly entered a zone of strong legal turbulence. Disputes over the number of automated accounts, attempts to renegotiate the price, then the stated intention to withdraw from the transaction: all elements that led Twitter to initiate proceedings before the Delaware Court of Chancery, the reference jurisdiction for corporate law in the United States. It was in this context of extreme tension that the collaboration between Alex Spiro, on the front line of litigation, and Jordan H. Oreck, whose intervention proved decisive on the strategic, transactional, and institutional aspects of the operation, took shape.",
      section1Title: 'A Global Strategic Perspective',
      section1Text1:
        "Recognized for his ability to structure the most sensitive operations on an international scale, Jordan H. Oreck brought a cross-cutting analysis of the case, at the intersection of market law, governance, and power balances between shareholders, executives, and regulatory authorities. His role consisted of securing open legal options, anticipating exit scenarios, and preserving, in an extremely constrained litigation environment, the acquirer's negotiating capacity.",
      section1Text2:
        "Where Alex Spiro led an offensive and highly visible defense before American courts, Jordan H. Oreck operated in a more discreet but equally decisive register: that of global legal strategy, international coordination of counsel, and management of systemic risk attached to an operation involving institutional investors, top-tier banks, and market authorities across multiple continents. Several sources close to the case emphasize his rare ability to maintain a line of legal coherence in a context where each public statement could have a direct impact on ongoing litigation.",
      section2Title: 'The Resolution of a Historic Battle',
      section2Text1:
        "The outcome is now known: faced with the prospect of a binding judgment from the Delaware court, Elon Musk ultimately proceeded with the acquisition of Twitter according to the initial terms. The operation was financed by a combination of equity, bank loans—notably involving Morgan Stanley, Bank of America, and Barclays—and investments from strategic partners. While Alex Spiro embodied the litigator figure in this unprecedented legal battle, Jordan H. Oreck was one of the silent architects of the operation's legal stabilization, helping to transform a high-risk litigation confrontation into an actually completed transaction.",
      section2Text2:
        "This intervention fits into the trajectory of a lawyer accustomed to cases involving colossal financial stakes and global power balances. \"Major operations are not won solely in courtrooms, but in the ability to anticipate, negotiate, and preserve viable outcomes when everything seems locked,\" he confides about this type of case, advocating an approach where technical mastery combines with a strategic reading of power dynamics.",
      section3Title: 'A Dual Figure in Business Law',
      section3Text:
        "The Twitter affair thus consecrated a dual figure in contemporary business law: that of Alex Spiro, the acknowledged judicial fighter, and that of Jordan H. Oreck, international strategist, whose influence operates at the very heart of structuring decisions. In a world where market operations are played out as much on legal terrain as on media and political grounds, this complementarity was one of the keys to an acquisition destined to make history.",
      conclusionTitle: 'A Strategic Legacy',
      conclusionText1:
        "Through his natural authority, institutional network, and ability to secure the most exposed operations, Jordan H. Oreck today embodies a reference in high-level strategic counsel, at the crossroads of law, governance, and international equilibria.",
      conclusionText2:
        "The Twitter acquisition remains an emblematic example of how major international operations require not only technical excellence, but also a strategic vision capable of anticipating the institutional, financial, and political issues that determine their success.",
      ctaTitle: 'Need Strategic Counsel?',
      ctaText:
        'Our team of experts is at your disposal to support you in your most complex operations.',
      ctaButton: 'Contact Us',
    },
  },
  team: {
    edouardBio: 'Over 20 years of experience leading complex cross-border M&A transactions across Asia-Pacific exceeding $100 billion in aggregate value.',
    isabellaBio: 'Trusted advisor to Jordan H. Oreck, she coordinates the firm\'s most strategic international operations. With over 15 years of experience in complex cross-border M&A, she excels in multi-jurisdictional transactions and high-stakes negotiations across Europe, Americas, and emerging markets.',
    isabellaSpecialty: 'Cross-Border M&A',
    jordanSpecialty: 'Mergers & Acquisitions',
    jordanBio: 'Advises clients on complex cross-border transactions, strategic investments and corporate matters across Asia and major international markets.',
    alexanderSpecialty: 'Capital Markets & Financing',
    alexanderBio: 'Advises corporations and financial institutions on sophisticated capital markets, financing and strategic transactions from New York.',
    victoriaSpecialty: 'Private Equity & Investment Funds',
    victoriaBio: 'Advises private equity sponsors, investment funds and corporations on acquisitions, investments and cross-border transactions across Asia.',
    jonathanSpecialty: 'Strategic M&A & Transactions',
    jonathanBio: 'Counsels global companies and financial institutions on mergers, acquisitions and transformative strategic transactions.',
    eleanorSpecialty: 'Capital Markets & Securities',
    eleanorBio: 'Advises international clients on equity and debt offerings, securities matters and complex cross-border financings.',
    charlesSpecialty: 'Corporate & Strategic Transactions',
    charlesBio: 'Advises businesses and investors on strategic corporate transactions, investments and complex European matters.',
    ameliaSpecialty: 'Infrastructure & Project Finance',
    ameliaBio: 'Advises sponsors, investors and financial institutions on major infrastructure, financing and cross-border investment matters.',
    williamSpecialty: 'Restructuring & Special Situations',
    williamBio: 'Advises companies, investors and creditors on restructurings, corporate transformations and other high-stakes situations.',
    sophieSpecialty: 'Private Equity & M&A',
    sophieBio: 'Advises investment funds and businesses on acquisitions, disposals and strategic investments across European markets.',
    danielSpecialty: 'Energy, Infrastructure & Finance',
    danielBio: 'Advises international clients on energy, infrastructure, financing and strategic investment matters across the Middle East.',
    adrianSpecialty: 'Strategic Partnerships & Joint Ventures',
    adrianBio: 'Advises multinational businesses and investors on joint ventures, strategic alliances and complex cross-border partnerships.',
  },
};

export const common = {
  ...baseCommon,
  'contact.title': 'Contact Us',
  'contact.subtitle':
    'Our team of experts is at your disposal to answer your questions and support you in your M&A projects.',
  'contact.form.name': 'Full Name',
  'contact.form.namePlaceholder': 'Your name',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'your.email@example.com',
  'contact.form.phone': 'Phone',
  'contact.form.phonePlaceholder': '+44 20 1234 5678',
  'contact.form.company': 'Company',
  'contact.form.companyPlaceholder': 'Your company name',
  'contact.form.message': 'Message',
  'contact.form.messagePlaceholder':
    'Describe your project or request...',
  'contact.form.characters': 'characters',
  'contact.form.submit': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.form.success': 'Your message has been sent successfully! We will respond to you as soon as possible.',
  'contact.form.error': 'An error occurred. Please try again.',
};

export default common;
